<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1,0.9999999403953552L15,0.9999999403953552C15.6,0.9999999403953552,16,1.3999999403953551,16,1.9999999403953552L16,12.999999940395355C16,13.599999940395355,15.6,13.999999940395355,15,13.999999940395355L1,13.999999940395355C0.4,13.999999940395355,0,13.599999940395355,0,12.999999940395355L0,1.9999999403953552C0,1.3999999403953551,0.4,0.9999999403953552,1,0.9999999403953552ZM2,11.999999940395355L8,11.999999940395355L8,2.9999999403953552L2,2.9999999403953552L2,11.999999940395355ZM14,11.999999940395355L9,11.999999940395355L9,2.9999999403953552L14,2.9999999403953552L14,11.999999940395355ZM13,3.9999999403953552L10,3.9999999403953552L10,4.999999940395355L13,4.999999940395355L13,3.9999999403953552ZM13,5.999999940395355L10,5.999999940395355L10,6.999999940395355L13,6.999999940395355L13,5.999999940395355ZM13,7.999999940395355L10,7.999999940395355L10,8.999999940395355L13,8.999999940395355L13,7.999999940395355ZM13,9.999999940395355L10,9.999999940395355L10,10.999999940395355L13,10.999999940395355L13,9.999999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'PanelStats',
} as DefineComponent
</script>
